"use client";
import { cn as e } from "../../lib/utils.js";
import { jsx as t } from "react/jsx-runtime";
import { Switch as n } from "@base-ui/react/switch";
//#region src/components/Switch/Switch.tsx
function r({ className: r, ...i }) {
	return /* @__PURE__ */ t(n.Root, {
		"data-slot": "switch",
		className: e("focus-visible:ring-ic-web-primary/50 data-checked:bg-ic-web-heading data-unchecked:bg-ic-web-border peer inline-flex h-5 w-9 shrink-0 cursor-pointer items-center rounded-full border-2 border-transparent shadow-xs transition-colors focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:outline-none data-disabled:cursor-not-allowed data-disabled:opacity-50", r),
		...i,
		children: /* @__PURE__ */ t(n.Thumb, {
			"data-slot": "switch-thumb",
			className: "bg-ic-web-background pointer-events-none block size-4 rounded-full shadow-lg transition-transform data-checked:translate-x-4 data-unchecked:translate-x-0"
		})
	});
}
//#endregion
export { r as Switch };
